export const Endpoints = {
  auth: {
    login:          '/users/login',
    register:       '/users/register',
    refresh:        '/users/refresh-token',
    logout:         '/users/logout',
    me:             '/users/me',
    forgotPassword: '/users/forgot-password',
    resetPassword:  '/users/reset-password',
  },
  todos: '/todos',
  expenses: '/expenses',
  habits: '/habits',
  matrix: '/matrix',
  calendar: '/calendar',
  feynman: '/feynman',
  pomodoro: '/pomodoro',
  journal: '/journal',
  goals: {
    objectives: '/goals/objectives',
    keyResults: '/goals/key-results',
  },
  kanban: {
    boards: '/kanban/boards',
    columns: (boardId: string) => `/kanban/boards/${boardId}/columns`,
    deleteColumn: (columnId: string) => `/kanban/columns/${columnId}`,
    cards: (columnId: string) => `/kanban/columns/${columnId}/cards`,
    moveCard: (cardId: string) => `/kanban/cards/${cardId}/move`,
    deleteCard: (cardId: string) => `/kanban/cards/${cardId}`,
  },
  flashcards: {
    decks: '/flashcards/decks',
    cards: (deckId: string) => `/flashcards/decks/${deckId}/cards`,
    due: (deckId: string) => `/flashcards/decks/${deckId}/due`,
    review: (cardId: string) => `/flashcards/cards/${cardId}/review`,
    deleteCard: (cardId: string) => `/flashcards/cards/${cardId}`,
  },
  reading: '/reading',
  timeBlocks: '/time-blocks',
  tenants: {
    list:       '/tenants',
    create:     '/tenants',
    users:      (id: string) => `/tenants/${id}/users`,
    invite:     (id: string) => `/tenants/${id}/users/invite`,
    createUser: (id: string) => `/tenants/${id}/users/create`,
    removeUser: (tenantId: string, userId: string) => `/tenants/${tenantId}/users/${userId}`,
  },
  invitations: {
    accept: '/invitations/accept',
  },
  family: {
    space:           '/family',
    leave:           '/family/leave',
    invite:          '/family/invite',
    join:            '/family/join',
    removeMember:    (userId: string) => `/family/members/${userId}`,
    adminDissolve:   (familySpaceId: string) => `/family/admin/${familySpaceId}`,
    todos:           '/family/todos',
    calendar:        '/family/calendar',
    kanban:          '/family/kanban',
    goals:           '/family/goals',
    expenses:        '/family/expenses',
    deleteExpense:   (expenseId: string) => `/family/expenses/${expenseId}`,
  },
  plans: {
    all:        '/plans',
    byId:       (id: string) => `/plans/${id}`,
    current:    '/plans/me',
  },
  admin: {
    // ── Plans Management (SuperAdmin) ──
    plans: {
      list:   '/plans',
      create: '/plans',
      update: (planId: string) => `/plans/${planId}`,
      assign: {
        user:   (userId: string) => `/plans/assign/user/${userId}`,
        tenant: (tenantId: string) => `/plans/assign/tenant/${tenantId}`,
      },
    },
    // ── User Management (SuperAdmin) ──
    users: {
      all:          '/admin/users',
      detail:       (userId: string) => `/admin/users/${userId}`,
      update:       (userId: string) => `/admin/users/${userId}`,
      toggleStatus: (userId: string) => `/admin/users/${userId}/status`,
      assignPlan:   (userId: string) => `/admin/users/${userId}/plan`,
    },
    // ── Tenant Management (SuperAdmin) ──
    tenants: {
      list:           '/tenants',
      create:         '/tenants',
      detail:         (tenantId: string) => `/tenants/${tenantId}`,
      update:         (tenantId: string) => `/tenants/${tenantId}`,
      settings:       (tenantId: string) => `/tenants/${tenantId}/settings`,
      updateSettings: (tenantId: string) => `/tenants/${tenantId}/settings`,
      users:          (tenantId: string) => `/tenants/${tenantId}/users`,
    },
    // ── System Settings (SuperAdmin) ──
    settings: {
      get:    '/admin/settings',
      update: '/admin/settings',
    },
    // ── Analytics (SuperAdmin) ──
    analytics: {
      overview: '/admin/analytics/overview',
      users:    '/admin/analytics/users',
      revenue:  '/admin/analytics/revenue',
      tenants:  '/admin/analytics/tenants',
    },
  },
  subscription: {
    createCheckoutSession: '/subscription/create-checkout-session',
    config:                '/subscription/config',
  },
  search: (q: string) => `/search?q=${encodeURIComponent(q)}`,
}
